import { request } from '../request'

/** 当前登录用户菜单树（DB 驱动，空则前端降级内置菜单） */
export function getMyMenus(data) {
  return request('system/getMyMenus', data)
}

/** 全部菜单（管理端） */
export function listMenus(data) {
  return request('system/listMenus', data)
}

/** 新增/更新菜单 */
export function saveMenu(data) {
  return request('system/saveMenu', data)
}

/** 删除菜单 */
export function delMenu(data) {
  return request('system/delMenu', data)
}

/** 全部数据权限配置（管理端） */
export function listPerms(data) {
  return request('system/listPerms', data)
}

/** 保存角色数据权限 */
export function savePerm(data) {
  return request('system/savePerm', data)
}
